export default __webpack_public_path__ + "static/media/bg-finance.48848abf.jpg";